document.addEventListener('DOMContentLoaded', function() {
  const shareBtn = document.querySelector('.btn-share');

  if(shareBtn) {
    shareBtn.addEventListener('click', handleShare);
  }

  async function handleShare() {
    const shareData = {
      title: '<?= esc_js($post_title) ?>',
      text: '<?= esc_js($post_title) ?>',
      url: window.location.href
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copiado para a área de transferência!');
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
      console.error('Erro ao compartilhar', error);
    }
  }
});